module.exports = __webpack_public_path__ + "static/media/sandyBairds65.ce97136a.png";